import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  classifierConfigsApi,
  type ClassifierConfig,
  type CreateClassifierConfigInput,
  type UpdateClassifierConfigInput,
} from '@/lib/api/classifier-configs.api';

const QK = ['classifier-configs'];

export function useClassifierConfigList() {
  return useQuery<ClassifierConfig[]>({ queryKey: QK, queryFn: classifierConfigsApi.list });
}

export function useClassifierConfigDetail(id: string | undefined) {
  return useQuery<ClassifierConfig>({
    queryKey: [...QK, id],
    queryFn: () => classifierConfigsApi.getById(id!),
    enabled: !!id,
  });
}

export function useCreateClassifierConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateClassifierConfigInput) => classifierConfigsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdateClassifierConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateClassifierConfigInput }) =>
      classifierConfigsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeleteClassifierConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => classifierConfigsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
